// extracted by mini-css-extract-plugin
export default {"container":"FacilityItem_container__NiqnK","icon":"FacilityItem_icon__gl5bH","name":"FacilityItem_name__Rz-yO","active":"FacilityItem_active__r1zS-"};